import React, { useState, useEffect } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import { API } from '../../../API/API';
import PageHeader from '../../../components/PageHeader/PageHeader';
import ColEdit from '../../../components/ColEdit/ColEdit';
import { useNavigate } from 'react-router-dom';

const TerminatedReport = (props) => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [columns] = useState([{
        name: 'Ажилтны нэр',
        fieldName: 'firstname',
        minColSize: 'mid',
        onRender: (item) => {
            return (
                <ColEdit onClick={() => onPressEmp(item.empid)}>{item.firstname}</ColEdit>
            );
        }
    }, {
        name: 'Хуулийн этгээд',
        fieldName: 'companyname'
    }, {
        name: 'Ажлын байр/Албан тушаал',
        fieldName: 'positionname'
    }, {
        name: 'Тушаалын дугаар ',
        fieldName: 'orderno'
    }, {
        name: 'Ажлаас чөлөөлөх төрөл',
        fieldName: 'terminatetypename'
    }, {
        name: 'Шалтгаан',
        fieldName: 'histreasonnames'
    }, {
        name: 'Ажлаас чөлөөлсөн огноо',
        fieldName: 'enddate'
    },
    {
        name: 'Даатгуулагчийн төрөл',
        fieldName: 'insuretypename'
    }, {
        name: 'Хүйс',
        fieldName: 'empgendername'
    }]);
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        setLoading(true);
        let tData = [];

        await API.get('/api/humanresource/report/get_emp_terminate_report').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });

        setData(tData);
        setOData(tData);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);


    const onPressEmp = (p_empid) => {
        if (p_empid) {
            navigate('/hrsuite/employee/' + p_empid);
        }
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                title='Ажлаас гарсан'
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                dataCount={data?.length}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default TerminatedReport;